var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { AccountCircle, Logout } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { logoutRequest } from '@madbox/react_session_manager';
import NotificationsList from './NotificationsList';
var paperProps = {
    elevation: 0,
    sx: {
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        mt: 1.5,
        '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
        },
    },
};
export function UserDropdown(_a) {
    var anchorEl = _a.anchorEl, onClose = _a.onClose;
    var dispatch = useDispatch();
    return (_jsxs(Menu, __assign({ anchorEl: anchorEl, open: Boolean(anchorEl), onClose: onClose, onClick: onClose, PaperProps: paperProps, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: [_jsxs(MenuItem, __assign({ onClick: function () {
                    window.location.href = 'https://admin.madbox.io/#/profile';
                } }, { children: [_jsx(ListItemIcon, { children: _jsx(AccountCircle, {}, void 0) }, void 0), "Profile"] }), void 0), _jsx(Divider, {}, void 0), _jsx(NotificationsList, {}, void 0), _jsx(Divider, { sx: { my: 1 } }, void 0), _jsxs(MenuItem, __assign({ onClick: function () { return dispatch(logoutRequest()); } }, { children: [_jsx(ListItemIcon, { children: _jsx(Logout, { fontSize: "small" }, void 0) }, void 0), "Logout"] }), void 0)] }), void 0));
}
